export { default as Socials } from "./Socials";
